import React from 'react';
import { Helmet } from 'react-helmet';

const DEFAULT_SITE_NAME = 'GoldAPI.io';
const DEFAULT_SOCIAL_IMAGE = 'https://www.goldapi.io/images/goldapi-logo-512.png';

function LandingSeo({ title, description, canonicalUrl, openGraph = {}, twitter = {}, structuredData }) {
  const siteName = openGraph.siteName || DEFAULT_SITE_NAME;
  const socialImage = openGraph.image || DEFAULT_SOCIAL_IMAGE;

  return <Helmet>
    <meta charSet="utf-8" />
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta property="og:type" content={openGraph.type || 'website'} />
    <meta property="og:title" content={openGraph.title || title} />
    <meta property="og:description" content={openGraph.description || description} />
    <meta property="og:url" content={canonicalUrl} />
    <meta property="og:site_name" content={siteName} />
    <meta property="og:image" content={socialImage} />
    <meta property="og:image:secure_url" content={socialImage} />
    <meta property="og:image:type" content="image/png" />
    <meta property="og:image:width" content="512" />
    <meta property="og:image:height" content="512" />
    <meta property="og:image:alt" content={openGraph.imageAlt || `${siteName} logo`} />
    <meta name="twitter:card" content={twitter.card || 'summary'} />
    <meta name="twitter:title" content={twitter.title || openGraph.title || title} />
    <meta name="twitter:description" content={twitter.description || openGraph.description || description} />
    <meta name="twitter:image" content={twitter.image || socialImage} />
    <meta name="twitter:image:alt" content={twitter.imageAlt || openGraph.imageAlt || `${siteName} logo`} />
    <link rel="canonical" href={canonicalUrl} />
    {structuredData && <script type="application/ld+json">{JSON.stringify(structuredData)}</script>}
  </Helmet>;
}

export default LandingSeo;
